import { useCallback } from 'react';
import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useStripe, useElements } from '@stripe/react-stripe-js';
import api from 'client';
import { communicationsMethods, routes } from 'const';
import { useFetchConfiguration, useStripeContext } from 'hooks';

export default (skipStripe = false) => {
  const { i18n } = useTranslation();
  const { isEnabledField } = useFetchConfiguration();
  const isPaymentEnabled = isEnabledField('payments');
  const { clientSecret: stripeClientSecret } = skipStripe || useStripeContext();
  const organizationId = new URLSearchParams(window.location.href).get('oid');
  let stripe;
  let elements;
  let requestResponse;
  try {
    stripe = useStripe();
    elements = useElements();
    // eslint-disable-next-line no-empty
  } catch (err) {}

  const bookOnlineIntake = useCallback(
    async ({
      availabilityPreferences,
      preferredCommunication,
      isrequestAppointment,
      paymentInformation,
      isPatientInsured,
      formattedAddress,
      birthDate,
      profile,
      config,
      ...restFields
    }) => {
      await api
        .post(
          '/apis/v2/online_intake',
          {
            ...restFields,
            patientId: profile?.patientId,
            birthDate: birthDate?.toJSDate(),
            stripeClientSecret,
            language: i18n.language,
            formattedAddress: formattedAddress?.description ? formattedAddress.description : formattedAddress,
            morningTiming: availabilityPreferences.morning,
            afternoonTiming: availabilityPreferences.afternoon,
            eveningTiming: availabilityPreferences.evening,
            isSmsConsented: preferredCommunication?.includes(communicationsMethods.textSms) || false,
            isEmailConsented: preferredCommunication?.includes(communicationsMethods.email) || false,
            isCallConsented: preferredCommunication?.includes(communicationsMethods.voice) || false,
            isPatientInsured: isPatientInsured ? isPatientInsured === 'true' : undefined,
            requestAnAppointment: isrequestAppointment,
          },
          config,
        )
        .then((response) => {
          requestResponse = response;
        });

      if (stripe && elements && isPaymentEnabled && paymentInformation && paymentInformation.complete) {
        const stripeResponse = await stripe.confirmSetup({
          elements,
          confirmParams: {
            return_url: `${document.location.origin}${routes.unauthenticatedBookingThankYou}`,
          },
          redirect: 'if_required',
        });
        const { error: stripeError } = stripeResponse;
        if (stripeError) {
          throw new Error(stripeError.message);
        } else {
          await api.put('/apis/v2/patient/payment_method', {
            payment_method_id: stripeResponse.setupIntent.payment_method,
            default_stripe_card: true,
            account_id: requestResponse.data.data.attributes.patientAccountId,
            oid: organizationId,
          });
        }
      }
    },
  );

  const bookOnlineIntakeMutation = useMutation(bookOnlineIntake, {
    onSuccess: async () => {},
    onError: (error) => {
      if (error.response?.data?.message) {
        toast.error(error.response?.data?.message);
      } else if (error.message) {
        toast.error(error.message);
      } else {
        toast.error("I'm sorry. We cannot process your request at the moment. Please give us a call");
      }
      throw error;
    },
  });

  return {
    bookOnlineIntakeMutation,
  };
};
